export default "__VITE_ASSET__BMKji49S__"